import { getAuthCookie } from './cookies';

export class RequestError extends Error {
  constructor(status, message, response = {}) {
    super(message);
    this.status = status;
    this.response = response;
  }
}

export const jsonifyResponse = (response) => {
  if (!response.ok) {
    return response
      .clone()
      .json()
      .catch(() => response.text())
      .then((payload) => {
        throw new RequestError(response.status, payload && (payload.Message || payload), payload);
      });
  }
  return response.json().catch(() => ({}));
};

export const buildBearerHeader = () => {
  return `Bearer ${getAuthCookie()}`;
};

export const post = (url, _body) => {
  const body = _body ? _body : {};
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: buildBearerHeader(),
    },
    body: JSON.stringify(body),
  };
  return fetch(url, options).then(jsonifyResponse);
};

export const requestDelete = (url, body = {}) => {
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: buildBearerHeader(),
    },
    body: JSON.stringify(body),
  };
  return fetch(url, options).then(jsonifyResponse);
};

export const get = (url) => {
  const options = {
    method: 'GET',
    headers: {
      Authorization: buildBearerHeader(),
    },
  };
  return fetch(url, options).then(jsonifyResponse);
};

export const put = (url, body) => {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: buildBearerHeader(),
    },
    body: JSON.stringify(body),
  };
  return fetch(url, options).then(jsonifyResponse);
};

export const uploadFile = (url, file) => {
  const data = new FormData();
  data.append('file', file);
  const options = {
    method: 'POST',
    headers: {
      Authorization: buildBearerHeader(),
    },
    body: data,
  };
  return fetch(url, options).then(jsonifyResponse);
};

export const uploadFiles = (url, file) => {
  const data = new FormData();

  data.append('file', file);

  const options = {
    method: 'POST',
    headers: {
      Authorization: buildBearerHeader(),
    },
    body: data,
  };
  return fetch(url, options).then(jsonifyResponse);
};

export const uploadAllFiles = (url, files) => {
  const data = new FormData();

  files.forEach((file, index) => {
    data.append(`file${index ? index + 1 : ''}`, file);
  });

  const options = {
    method: 'POST',
    headers: {
      Authorization: buildBearerHeader(),
    },
    body: data,
  };

  return fetch(url, options).then(jsonifyResponse);
};

export const downloadBlob = (url, method = 'GET', body = '') => {
  let options = {
    method: method,
    headers: {
      Authorization: buildBearerHeader(),
    },
  };
  if (body !== '') {
    options = {
      body: JSON.stringify(body),
      method: method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: buildBearerHeader(),
      },
    };
  }
  return fetchBlob(url, options);
};

function fetchBlob(url, options) {
  return fetch(url, options).then((response) => {
    if (!response.ok) {
      throw new RequestError(response.status, response.message);
    }
    return response.blob();
  });
}



// WEBPACK FOOTER //
// src/utils/requests.js